import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OnboardingState {
  approvalStatus: number | null;
  approvalStatusText: string | null;
  isOnBoardingStatus: boolean | null;
  reason?: string | null;
}

const initialState: OnboardingState = {
  approvalStatus: null,
  approvalStatusText: null,
  isOnBoardingStatus: null,
  reason: null,
};

const onboardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    setOnboardingData: (state, action: PayloadAction<OnboardingState>) => {
      return action.payload;
    },

    updateOnboardingData: (
      state,
      action: PayloadAction<Partial<OnboardingState>>
    ) => {
      Object.assign(state, action.payload);
    },

    resetOnboardingData: () => initialState,
  },
});

export default onboardingSlice.reducer;

export const { setOnboardingData, updateOnboardingData, resetOnboardingData } =
  onboardingSlice.actions;
